import { TContract, UseMzQuery, useAjax, useMzQuery } from "@harea/component"
import { ContractManagerQuery } from "../queries/ContractManagerQuery"
import { useCallback, useMemo } from "react"

const isNotFoundError = (error: any): boolean => {
    const errors = error?.response?.errors ?? error?.errors
    if (Array.isArray(errors)) {
        return errors.some((item: any) =>
            item?.message === "NOT_FOUND" || item?.extensions?.code === "NOT_FOUND"
        )
    }
    return String(error?.message ?? "").includes("NOT_FOUND")
}

export const useContractManagerQuery = (userId?: number, type?: string, suspense?: boolean): UseMzQuery<TContract, any> => {
    const ajax = useAjax()

    const query = useMemo(() => new ContractManagerQuery({
        data: {
            user: { id: userId }
        },
        leaveTypeDesignation: type
    }), [userId, type])

    const gqlFn = useCallback(async (): Promise<TContract> => {
        try {
            const response = await ajax.graphql(query.gql, query.variables)
            return query.mapFn?.(response) ?? null
        } catch (error) {
            // Un employé peut ne pas avoir de contrat validé/actif :
            // le backend renvoie NOT_FOUND, on résout vers null au lieu de planter l'UI.
            if (isNotFoundError(error)) {
                console.warn("useContractManagerQuery: no active contract found", { userId })
                return null
            }
            throw error
        }
    }, [ajax, query])

    return useMzQuery<TContract>(
        [query.queryKey, query.variables],
        gqlFn,
        { suspense, enabled: !!userId && userId != -1 }
    )
}
